/**
 * Copyright (c) 2026 Accunai India Services Pvt. Ltd. All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This file is part of proprietary software owned by Accunai India Services Pvt. Ltd.
 * Unauthorized copying, distribution, modification, or use of this file,
 * in whole or in part, via any medium, is strictly prohibited without
 * prior written permission from Accunai India Services Pvt. Ltd.
 *
 * Generated with GitHub Copilot Business/Enterprise.
 * Reviewed and approved by: AI-assisted / 2026-08-13
 */

import { httpClient } from "./httpClient";

interface ProjectRecord {
  id: string;
  [key: string]: unknown;
}

interface ProjectListQuery {
  id?: string;
  projectId?: string;
  search?: string;
  page?: number;
  pageSize?: number;
  paginate?: boolean;
  sort?: string;
  order?: "asc" | "desc" | string;
  fields?: string;
}

interface ProjectListApiResponse {
  count?: number;
  results?: ProjectRecord[];
}

interface UpdateProjectInput {
  id?: string;
  [key: string]: unknown;
}

interface UpdateProjectApiResponse {
  data?: ProjectRecord | null;
  message?: string;
  [key: string]: unknown;
}

interface FetchProjectTypesInput {
  dataCategory?: string;
  paginate?: boolean;
}

interface FetchTaskCategoriesInput {
  annotationMethod?: string;
  paginate?: boolean;
}

interface ProjectOptionRecord {
  id: string;
  name: string;
  value: string;
}

interface OptionsResponseObject {
  count?: number;
  results?: ProjectOptionRecord[];
}

type OptionsApiResponse = ProjectOptionRecord[] | OptionsResponseObject;

interface ProjectExportApiResponse {
  data?: string;
  message?: string;
  [key: string]: unknown;
}

const PROJECT_USER_PATH = "project/user";
const PROJECT_COMPANY_PATH = "project/company/";
const ANNOTATION_METHODS_PATH = "annotation-methods";
const TASK_CATEGORY_PATH = "task/category";
const PROJECT_EXPORT_PATH = "project/company/export";

export const getProjectsApi = async (
  input: ProjectListQuery = {}
): Promise<ProjectListApiResponse> => {
  const response = await httpClient.get<ProjectListApiResponse>(PROJECT_USER_PATH, {
    params: {
      id: input.id,
      project_id: input.projectId,
      search: input.search,
      page: input.page,
      page_size: input.pageSize,
      paginate: input.paginate,
      sort: input.sort,
      order: input.order,
      fields: input.fields,
    },
  });

  return response.data;
};

export const updateProjectApi = async (
  payload: UpdateProjectInput
): Promise<UpdateProjectApiResponse> => {
  const response = await httpClient.patch<UpdateProjectApiResponse>(PROJECT_COMPANY_PATH, payload);
  return response.data;
};

export const fetchProjectTypesApi = async (
  input: FetchProjectTypesInput
): Promise<OptionsApiResponse> => {
  const response = await httpClient.get<OptionsApiResponse>(ANNOTATION_METHODS_PATH, {
    params: {
      data_category: input.dataCategory,
      paginate: input.paginate,
    },
  });

  return response.data;
};

export const fetchTaskCategoriesApi = async (
  input: FetchTaskCategoriesInput
): Promise<OptionsApiResponse> => {
  const response = await httpClient.get<OptionsApiResponse>(TASK_CATEGORY_PATH, {
    params: {
      annotation_method: input.annotationMethod,
      paginate: input.paginate,
    },
  });

  return response.data;
};

export const getProjectExportApi = async (params: {
  associationType?: string;
} = {}): Promise<ProjectExportApiResponse> => {
  const response = await httpClient.get<ProjectExportApiResponse>(PROJECT_EXPORT_PATH, {
    params: {
      association_type: params.associationType,
    },
  });

  return response.data;
};
